var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudCenter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 46,
    viewBox: "0 0 163 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.8221 0.666689C66.8614 -1.99036 83.8937 3.5049 91.202 13.4085C96.1546 9.18134 105.094 7.61126 112.16 9.8456C119.227 12.0799 123.817 17.8168 122.911 23.312C132.394 16.0051 151.299 17.1525 158.969 25.486C162.049 28.8073 163.318 33.3364 160.721 36.8992C157.036 41.7906 148.037 42.7568 140.306 42.9984C102.859 44.3873 71.1496 45.7762 34.4877 44.9308C24.5823 44.6892 -0.0602877 44.9308 0.000110828 33.8798C0.0605094 23.5536 15.8246 20.353 24.6428 24.7009C26.3943 13.65 36.3601 3.38413 51.8221 0.666689Z",
    fill: "#3E809D",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCenter);
export default __webpack_public_path__ + "static/media/cloud-center.986b14b1531513077e498863488c5ac2.svg";
export { ForwardRef as ReactComponent };